import { DashboardModuleSummaryType } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import axios from 'axios'

class DashboardModuleService {
    // CLINICAL MODULE
    async getSummaryOfUnseenRequests(): Promise<number> {
        const response = await axios.get<number>(`/clinical/requests/unseen/summary`)
        return response.data
    }

    async getSummaryOfLockedRequests(): Promise<number> {
        const response = await axios.get<number>(`/clinical/requests/locked/summary`)
        return response.data
    }

    async getSummaryOfRegisteredTodayCases(laboratoryId:number): Promise<number> {
        const response = await axios.get<number>(`/registry/laboratories/${laboratoryId}/cases/registeredToday/summary`)
        return response.data
    }

    async getSummaryOfRequestedRequests(laboratoryId: number): Promise<number> {
        const response = await axios.get<number>(`/registry/laboratories/${laboratoryId}/requests/requested/summary`)
        return response.data
    }

    async getSummaryOfRegistryLockedRequests(laboratoryId: number): Promise<number> {
        const response = await axios.get<number>(`/registry/laboratories/${laboratoryId}/requests/locked/summary`)
        return response.data
    }

    async getSummaryOfPortionsPendingCut(laboratoryId: number, sectionIds: number[]): Promise<number> {
        const response = await axios.get<number>(`/laboratory/laboratories/${laboratoryId}/cases/samples/portions/pendingCut/summary`, { params: { sectionIds } })
        return response.data
    }

    async getSummaryOfPortionsPendingMake(laboratoryId: number, sectionIds: number[]): Promise<number> {
        const response = await axios.get<number>(`/laboratory/laboratories/${laboratoryId}/cases/samples/portions/pendingMake/summary`, { params: { sectionIds } })
        return response.data
    }

    async getSummaryOfSubPortionsPendingScan(laboratoryId: number, sectionIds: number[]): Promise<number> {
        const response = await axios.get<number>(`/laboratory/laboratories/${laboratoryId}/cases/samples/portions/subportions/pendingScan/summary`, { params: { sectionIds } })
        return response.data
    }

    async getSummaryOfSubPortionsPendingToScanner(laboratoryId: number, sectionIds: number[]): Promise<number> {
        const response = await axios.get<number>(`/laboratory/laboratories/${laboratoryId}/cases/samples/portions/subportions/pendingToScanner/summary`, { params: { sectionIds } })
        return response.data
    }

    async getSummaryOfSamplesDisposedToday(laboratoryId: number): Promise<number> {
        const response = await axios.get<number>(`/waste/laboratories/${laboratoryId}/samples/disposedToday/summary`)
        return response.data
    }

    async getSummaryOfSamplesPendingDisposal(laboratoryId: number): Promise<number> {
        const response = await axios.get<number>(`/waste/laboratories/${laboratoryId}/samples/pendingDisposal/summary`)
        return response.data
    }

    async getSummaryOfOpenIncidentsByLoggedInUser(laboratoryId: number): Promise<number> {
        const response = await axios.get<number>(`/incident/laboratories/${laboratoryId}/incidents/open/summary`)
        return response.data
    }

    async getSummaryOfSamplesPendingProcessing(laboratoryId: number, grossingWidgetSummaryType?: DashboardModuleSummaryType): Promise<number> {
        const response = await axios.get<number>(`/grossing/laboratories/${laboratoryId}/cases/samples/pendingProcessing/summary`, { params: { grossingWidgetSummaryType } })
        return response.data
    }

    async getSummaryOfSamplesPendingReProcessing(laboratoryId: number, grossingWidgetSummaryType?: DashboardModuleSummaryType): Promise<number> {
        const response = await axios.get<number>(`/grossing/laboratories/${laboratoryId}/cases/samples/pendingReprocessing/summary`, { params: { grossingWidgetSummaryType } })
        return response.data
    }

    async getSummaryOfProcessedTodaySamples(laboratoryId: number, grossingWidgetSummaryType?: DashboardModuleSummaryType): Promise<number> {
        const response = await axios.get<number>(`/grossing/laboratories/${laboratoryId}/cases/samples/processedToday/summary`, { params: { grossingWidgetSummaryType } })
        return response.data
    }
}

export const dashboardModuleService = new DashboardModuleService()
